export default __webpack_public_path__ + "static/media/1994.68a4bbf1.png";